import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonService } from '../../service/common.service';
import { StaffingService } from 'src/app/staffing/staffing.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpStatusCode } from '@angular/common/http';
import { LoggedInUserKeys, LoggedInUserService } from '../../service/logged-in-user.service';
import { AppUsersDto } from '../../model/app-users-dto';

type Row = {
  id: string;
  srId: string;
  role: string;
  grade: string;
  costCentreLine1: string;
  costCentreLine2?: string;
  clientName: string;
  clientSub?: string;
  location: string;
  ageing: string;
  status: 'Open' | 'On Hold';
  candidate: {
    name: string;
    initials: string;
    title: string;
    experience: string;
    score: number;
    avatar?: string;
  };
  employeeResponseDTO?: any;
  insights: string[];
  gaps: string[];
};
type StepKey =
  | 'open'
  | 'mapped'
  | 'recommended'
  | 'blocked'
  | 'selected'
  | 'closed';
  @Component({
    selector: 'app-candidate-modal-staffing',
    templateUrl: './candidate-modal-staffing.component.html',
    styleUrls: ['./candidate-modal-staffing.component.scss'],
    standalone: false
  })
  
  export class CandidateModalStaffingComponent implements OnChanges{
  getStoredQueryparamFromSession:any;
  constructor(
    public _commonServices: CommonService,
    private _staffingService: StaffingService,
    private router: Router,
    private _toast: ToastrService,
    private readonly loggedInUserService: LoggedInUserService,
  ) {
    this.getStoredQueryparamFromSession = JSON.parse(sessionStorage.getItem('queryParams')) ?? {};
    if (this.getStoredQueryparamFromSession['isNavigatedEmployeeHistory'] ?? false){
      this.displayedView ='EMPLOYEE_HISTORY'
    }
  }
  readonly defaultCloseImg = this._commonServices.Images.CLOSE_SEARCH;
  readonly hoverCloseImg = this._commonServices.Images.CLOSE_SEARCH_HOVER; 
  currentCloseImg = this._commonServices.Images.CLOSE_SEARCH;   

  // Add sort icon states
  readonly defaultsortImg = this._commonServices.Images.DEFAULT_SORT;
  readonly hoverSortImg = this._commonServices.Images.HOVER_DEFAULT_SORT;
  hoveredSortColumn: keyof typeof this.sortKeyMap | null = null;
  @Input() header = { title: 'Rajesh Rajput', empCode: 'F01547' };
  @Input() rows: Row[] = [];
  @Input() open = false;
  @Output() close = new EventEmitter<void>();
  
  // Decorators for EmployeeHistory
  @Output() searchChangeOnEmployeeHistory = new EventEmitter<string>();
  @Input() allEmployeeHistoryData: any[] = []; // All Employee Histroy data

  @Input() employeeDetailsForCandidate: any[] = [];
  
  // Pagination inputs
  @Input() page: number = 1;
  @Input() pageSize: number = 10;
  @Input() pageCount: number = 1;
  @Input() isLoadingMore: boolean = false;
  @Input() totalElements: number = 0;
  @Input() isPMViewNavigation: boolean = false; // booelean to check for pm view
  @Input() viewType :string = ''; // type of screen bench o sr view
  candidateDetailsModalData: any;
  loginUser: AppUsersDto;
  
  // Pagination output
  @Output() loadMore = new EventEmitter<void>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() openJDDescriptionModal = new EventEmitter<string>();
  @Output() openCalculationDetailModal = new EventEmitter<string>();
  @Output() rejectReccModal = new EventEmitter<any>();
  @Output() blockedCandidateModal = new EventEmitter<any>();
  @Output() unmapCandidateModal = new EventEmitter<any>();
  @Output() openAIinsightAndGapsAndOtherSrsModal = new EventEmitter<string>();
  @Output() openRecommendToPmModal = new EventEmitter<any>();
  @Output() applySort = new EventEmitter<any>();
  @Output() reTriggerAssessment = new EventEmitter<any>();
  @Output() handleOtherPayload = new EventEmitter<any>();
  query = '';
  expanded = new Set<string>();
  selected: Record<string, boolean> = {};

  @ViewChild('sortIcon', { static: true }) sortIconTpl!: TemplateRef<any>;
  @ViewChild('candidateTableScrollContainer')
  candidateTableScrollContainer?: ElementRef<HTMLElement>;
  @ViewChild('employeeHistoryScrollContainer')
  employeeHistoryScrollContainer?: ElementRef<HTMLElement>;
  SortIcon = {} as any;
  showBackToTop = false;
  SRStatsCount :any;
  ngOnChanges(changes: SimpleChanges): void {
    // Get the sr count
    if (changes['allEmployeeHistoryData']) {
      console.log('on allEmployeeHistoryData changes firred')
      this.updateStatsCount();
    }
  }
  ngOnInit() {
     this.loginUser = this.loggedInUserService.getLoggedInUser(
          LoggedInUserKeys.LOGGED_IN_USER,
    );
    console.log('allEmployeeHistoryData',this.allEmployeeHistoryData);
    console.log(this.rows, 'rows');
    (this as any).SortIcon = this.sortIconTpl;
      console.log(this.employeeDetailsForCandidate,'employeeDetailsForCandidate');    
    if (this.rows?.length === 0) this.rows = this.sampleRows();
    const selectedIdFromLocalStorage = localStorage.getItem('selectedIdOnCandidateModalStaffing');
    console.log(selectedIdFromLocalStorage,'selectedIdFromLocalStorage')
    if(selectedIdFromLocalStorage!=null){
      this.openId = selectedIdFromLocalStorage;
    }else{
       this.openId = null;
    }
  }

  trackById = (_: number, r: Row) => r.id;
  openId: string | null = null;
  isOpen = (id: string) => this.openId === id;

  toggle(id: string) {

    this.openId = this.openId === id ? null : id;
    if (this.openId) {
      // Save the newly opened accordion ID to localStorage
      localStorage.setItem('selectedIdOnCandidateModalStaffing', id.toString());
    } else {
      // Optional: If the user explicitly closes the accordion, remove it from storage
      localStorage.removeItem('selectedIdOnCandidateModalStaffing');
    }
     this.closeAll();
  }
  
  _query = '';

  private updateStatsCount(): void {
    this.SRStatsCount = this.allEmployeeHistoryData?.length > 0 
      ? this.allEmployeeHistoryData[0] 
      : {
          "candidatesMapped": 0,
          "candidatesRecommended": 0,
          "candidatesRejected": 0,
          "candidatesBlocked": 0,
          "candidatesSelected": 0,
          "benchStartDate": null
        };
  }
  
  onSearch() {
    // Emit search change to parent component for API-based search
    const searchTerm = this.query.trim();
    this._query = searchTerm.toLowerCase();
    if (this.displayedView=='MAPPED'){
      this.searchChange.emit(searchTerm);
    }else{
      console.log('Search not impl')
      this.searchChangeOnEmployeeHistory.emit(searchTerm);
    }
  }

  onSearchChange(value: string) {
    // Handle search input changes
    if (!value || value.trim().length === 0) {
      this._query = '';
       if (this.displayedView=='MAPPED'){
         this.searchChange.emit('');
       }else{
        // Need to implement search
        console.log('Search not impl')
        this.searchChangeOnEmployeeHistory.emit('');
       }
    }
  }

  get filteredRows(): Row[] {
    console.log(this.rows, 'rows for filtering');
    // Return all rows as filtering is done by API search
    return this.rows;
  }

  sampleRows(): Row[] {
    return [];
  }

  closeModal() {
    // this.displayedView  = 'MAPPED'; //reset
    // reset when close and set on local
    this.getStoredQueryparamFromSession['isNavigatedEmployeeHistory'] = false; 
    sessionStorage.setItem('queryParams', JSON.stringify(this.getStoredQueryparamFromSession));
    
    this.query  ='';
    this.searchChange.emit('');
    this.open = false;
    this.openId = null;
    this.showBackToTop = false;
    this.close.emit();
  }

  openOptionsMenu: boolean;
  currentRowForActions: Row | null = null;

  closeAll() {
    this.openOptionsMenu = null;
  }

  // Handle scroll for infinite scrolling
  onTableScroll(event: any) {
    const element = event.target as HTMLElement;
    const threshold = 100; // pixels from bottom

    this.showBackToTop = element.scrollTop > 200;
    
    if (
      element.scrollHeight - element.scrollTop - element.clientHeight <
      threshold
    ) {
      if (!this.isLoadingMore && this.page < this.pageCount) {
        this.loadMore.emit();
      }
    }
  }

  onEmployeeHistoryScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.showBackToTop = element.scrollTop > 200;
  }

  scrollToTop(): void {
    const activeScrollContainer =
      this.displayedView === 'EMPLOYEE_HISTORY'
        ? this.employeeHistoryScrollContainer
        : this.candidateTableScrollContainer;

    activeScrollContainer?.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  selectedCandidateList: any[] = [];
onToggleOptionsMenu(row: Row) {
  if (this.isOptionsDisabled(row)) {
    this.closeAll();
    return;
  }

  this.currentRowForActions = row;

  // toggle behavior
  this.openOptionsMenu =
    this.openOptionsMenu && this.currentRowForActions === row
      ? false
      : true;
}
  optionsKey :string  = '';
  onAction(row: Row, action: string) {
    console.log(row, 'row');
    console.log('Action:', action);
    if (action === 'cancel recommended') {
      this.optionsKey = 'reject recommended';
      this.openRejectRecommendedPopup(row);
      this.closeAll();
      return;
    }
    if (action === 'rejected') {
       this.optionsKey = action;
      this.openRejectRecommendedPopup(row);
      this.closeAll();
      return;
    }
    if (action =='block candidate'){
      this.openBlockedCandidatePopup(row);
      this.closeAll();
      return;
    }
    if (action === 'unmap candidate') {
      this.openUnmapCandidatePopup(row);
      this.closeAll();
      return;
    }
    else{
       const employee = row.employeeResponseDTO || {};
       const optionsPayload = {
         optionKey: action,
         srNumber: row.srId,
         employeeIds: [employee.employeeId || this.header.empCode],
       };
   
      //  this.staffingEmployeeOptions(optionsPayload);
      this.closeAll();
      this.handleOtherPayload.emit(optionsPayload) // Emitted data and  Handled at parent component
     }
  }

  loading: boolean = false;

  // staffingEmployeeOptions(optionsPayload) {
  //   this.loading = true;
  //   this._staffingService.staffingEmployeeOptions(optionsPayload).subscribe({
  //     next: (response) => {
  //       if (response && response.statusCode === 200) {
  //         console.log(response, 'res');
  //         this.query = ''; // Clear search text if any from UI
  //         this._toast.success(response.message, 'Success');
  //         setTimeout(() => { 
  //           this.searchChange.emit('');
  //           this.searchChangeOnEmployeeHistory.emit(''); // calling employee history api
  //         }, 600);
  //       } else {
  //         console.error('Error in response:', response);
  //       }
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       this.loading = false;
  //       console.error('API error:', err);
  //     },
  //   });
  // }
  

  viewProfile(value: any) {
     localStorage.setItem('selectedIdOnCandidateModalStaffing', value.id.toString());
     console.log(value);
    // 1. Define your base query parameters
      const queryParams: any = { 
        candidateId: this.header.empCode, 
        srNumber: value.srId,  
        employeeName: value.candidate.name ,
        modalOpen : true  // This will be in everycase when user navigates to profile
      };
      console.log(this.viewType,'viewType')
      if(this.viewType){
        if(this.viewType == 'BENCH_VIEW'){
          console.log(this.viewType,'viewType');
           console.log(this.viewType,'isFromAIMatching set to true');
          queryParams.viewType = 'BENCH_VIEW';
          sessionStorage.setItem('isFromAIMatching', 'true');
        }
        else{
          queryParams.viewType = 'SR_VIEW';
        }
      }  
      this.router.navigate(
        [this._commonServices.Navigations.VIEW_PROFILE_OF_MAPPED_CANDIDATE],
        { queryParams: queryParams }
      );
  }

  // recommendToPm Click Function
  recommendToPmFunc(data:any){
    if (this.isRecommendToPmDisabled(data)) return;

    console.log(data,'data')
    console.log(this.header.empCode,'Employee Id')
    localStorage.setItem('selectedIdOnCandidateModalStaffing', data.id.toString());
    const popupPayload = {
      srNumber: data.srId,
      selectedCandidateIds: new Set([this.header.empCode]),
      recommendedCandidateList: [data.employeeResponseDTO],
      profilesToSendMail: [],
      srDetailsToSendMail: []
    };
    this.openRecommendToPmModal.emit(popupPayload);
   
  }

  isStarHoverForId: string | null = null;
  starHideTimer: any = null;

  showStarHover(id: string) {
    this.clearStarHideTimer();
    this.isStarHoverForId = id;
  }

  scheduleStarHide() {
    this.clearStarHideTimer();
    this.starHideTimer = setTimeout(() => {
      this.isStarHoverForId = null;
    }, 50);
  }

  cancelStarHide() {
    this.clearStarHideTimer();
  }

  clearStarHideTimer() {
    if (this.starHideTimer) {
      clearTimeout(this.starHideTimer);
      this.starHideTimer = null;
    }
  }

  commonHoverForId: string | null = null;
  commonHideTimer: any = null;
  typeOfBot:string;


  showCommonHover(id: string,type:string) {
    this.clearCommonTimer();
    this.commonHoverForId = id;
    this.typeOfBot = type;
  }

  scheduleCommonHide() {
    this.clearCommonTimer();
    this.commonHideTimer = setTimeout(() => {
      this.commonHoverForId = null;
    }, 50);
  }

  cancelCommonHide() {
    this.clearCommonTimer();
  }

  clearCommonTimer() {
    if (this.commonHideTimer) {
      clearTimeout(this.commonHideTimer);
      this.commonHideTimer = null;
    }
  }

  assignReassessment(c) {
    console.log(c);
  }

  scoreBadgeClass(percent: number) {
    // if (percent >= 90) return ['bg-[#d2f4ce]', 'ring-[#9bea91]'];
    // if (percent >= 75) return ['bg-[#c3daf0]', 'ring-[#8cb9e2]'];
    if (percent >= 80) return ['bg-[#d2f4ce]', 'ring-[#9bea91]']; // Green
    if (percent >= 50) return ['bg-[#c3daf0]', 'ring-[#8cb9e2]']; // Blue
    return ['bg-rose-50', 'ring-rose-100'];
  }

  actionsConfig = [
  {
    key: 'select candidate',
    label: 'Select Candidate',
    visible: (c) =>
      c.srStatus === 'Open' &&
      this.getCandidateState(c) === 'BLOCKED' &&
      !this.isPMViewNavigation,
  },
  {
    key: 'de-select candidate',
    label: 'De-Select Candidate',
    visible: (c) =>
      this.getCandidateState(c) === 'SELECTED',
  },
  {
    key: 'block candidate',
    label: 'Block Candidate',
    visible: (c) =>
      c.srStatus === 'Open' &&
      this.getCandidateState(c) === 'RECOMMENDED' &&
      !this.isPMViewNavigation,
  },
  {
    key: 'unblock candidate',
    label: 'Unblock Candidate',
    visible: (c) =>
      c.srStatus === 'Open' &&
      this.getCandidateState(c) === 'BLOCKED',
  },
  {
    key: 'unmap candidate',
    label: 'Unmap Candidate',
    visible: (c) =>
      c.srStatus === 'Open' &&
      this.getCandidateState(c) === 'MAPPED',
  },
  {
    key: 'cancel recommended',
    label: 'Cancel Recommend',
    visible: (c) =>
      c.srStatus === 'Open' &&
      this.getCandidateState(c) === 'RECOMMENDED' &&
      !this.isPMViewNavigation,
  },
  {
    key: 'rejected',
    label: 'Reject Candidate',
    visible: (c) =>
      c.srStatus === 'Open' &&
      ['BLOCKED', 'SELECTED'].includes(this.getCandidateState(c)),
  }

  // {
  //   key: 'teams',
  //   label: 'Contact via Teams',
  //   visible: (c) =>
  //     c.srStatus === 'Open' &&
  //     this.getCandidateState(c) !== 'UNMAPPED',
  // },
  // {
  //   key: 'email',
  //   label: 'Contact via Email',
  //   visible: (c) =>
  //     c.srStatus === 'Open' &&
  //     this.getCandidateState(c) !== 'UNMAPPED',
  // },
  // {
  //   key: 'schedule',
  //   label: 'Schedule a Teams Meet',
  //   visible: (c) =>
  //     c.srStatus === 'Open' &&
  //     this.getCandidateState(c) !== 'UNMAPPED',
  // },
];

getCandidateState(c) {
  if (c.isCandidateSelected) return 'SELECTED';
  if (c.isBlocked) return 'BLOCKED';
  if (c.isRecommendedToPM) return 'RECOMMENDED';
  if (c.isMapped) return 'MAPPED';
  return 'UNMAPPED';
}
get visibleActions() {
  if (!this.currentRowForActions) return [];
   const matchedEmployee = 
  this.currentRowForActions?.employeeResponseDTO || 
  this.employeeDetailsForCandidate?.find(emp => emp.employeeId === this.currentRowForActions?.employeeResponseDTO?.employeeId) || 
  {};
  console.log(matchedEmployee,'matchedEmployee');

  const selected = [matchedEmployee];

  return this.actionsConfig.filter((action) => {
    if (action.key === 'rejected') {
      return selected.every((c) => action.visible(c));
    }

    return selected.some((c) => action.visible(c));
  });
}

isRecommendToPmDisabled(row: Row): boolean {
  const employee = row?.employeeResponseDTO || {};
  return !!employee?.isRecommendedToPM || this.isOptionsDisabled(row);
}

isOptionsDisabled(row: Row): boolean {
  const employee = row?.employeeResponseDTO || {};
  const isCurrentSrHandled = !!(employee?.isBlocked || employee?.isCandidateSelected);
  const isHandledOnAnotherSr =
    !!employee?.isSelectedOrBlocked ||
    (Array.isArray(employee?.blockedFor) && employee.blockedFor.length > 0);
  return !isCurrentSrHandled && isHandledOnAnotherSr;
}

onClickSRId(data:any,index?:any) {
  data.selectedIndex  = index;
  console.log('SR ID clicked:', data);
  this.openJDDescriptionModal.emit(data);
}

isCardDisabled(
    c?: {
      isBlocked?: boolean;
      isCandidateSelected?: boolean;
      isSelectedOrBlocked?: boolean;
      blockedFor?: string[];
    } | null,
  ): boolean {
    const isCurrentSrHandled = !!(c?.isBlocked || c?.isCandidateSelected);

    // Candidate is already handled on some other SR when either the flag indicates it,
    // or blockedFor has at least one SR id.
    const isHandledOnAnotherSr =
      !!c?.isSelectedOrBlocked ||
      (Array.isArray(c?.blockedFor) && c.blockedFor.length > 0);

    // Disabled state should apply only if not already blocked/selected for this SR,
    // but the candidate is handled elsewhere.
    return !isCurrentSrHandled && isHandledOnAnotherSr;
}

//  get Initials of Name
getInitial(name: string): string {
    return (name || '?').trim().charAt(0).toUpperCase();
}



openCalculationDetailsPopup(data: any) {
   console.log('Calculation details popup for row:', data);
   localStorage.setItem('selectedIdOnCandidateModalStaffing', data.id.toString());
   // Emit the complete row data so parent can extract employeeId and srId
   this.openCalculationDetailModal.emit(data);
}

openAiInsightModal( modalType: 'insights' | 'gaps' | 'otherSr' | 'recommended' | 'blocked',data:any){
  console.log('SR ID clicked:', data);
      console.log(modalType, data, 'modalType');
    if (modalType === 'insights') {
      this.candidateDetailsModalData = {
        title: 'AI Insights',
        items: data.insights,
        employeeName: data.employeeResponseDTO.employeeName,
        employeeId: data.employeeResponseDTO.employeeId,
      };
    } else if (modalType === 'gaps') {
      this.candidateDetailsModalData = {
        title: 'Gaps',
        items: data.gaps,
        employeeName: data.employeeResponseDTO.employeeName,
        employeeId: data.employeeResponseDTO.employeeId,
      };
    } else if (modalType === 'otherSr') {
      this.candidateDetailsModalData = {
        title: 'Other SRs Mapped',
        items: data.otherSrMapped,
      };
    }
  this.openAIinsightAndGapsAndOtherSrsModal.emit(this.candidateDetailsModalData);
}
  activeSortColumn :any  =  null;
  sortDirection :any =  null;

  onSort(column: keyof typeof this.sortKeyMap) {
    const isSameColumn = this.activeSortColumn === column;
    if (!isSameColumn) {
      this.activeSortColumn = column;
      this.sortDirection = 'asc';
    } else if (this.sortDirection === 'asc') {
      this.sortDirection = 'desc';
    } else {
      // 3rd click: reset sort for this column
      this.activeSortColumn = null;
      this.sortDirection = null;
    }
    this.applySort.emit({direction:this.sortDirection,column:this.activeSortColumn,searchKey:this.query});

  }

  sortKeyMap: Record<string, string> = {
    srNumber: 'srNumber',
    grade :'grade',
    designation :'designation',
    costCentre:'costCentre',
    clientName :'clientName',
    status:'status',
    city :'city',
    ageing :'ageing'
  };

   // Per-card expand state for AI Insights and Gaps (shared - toggled together)
  expandedInsightCards = new Set<string>();
  expandedGapCards = new Set<string>();

  /**
   * Get the first 30 words from text, or all if less than 30
   */
  getPreviewText(text: string, wordLimit: number = 30): string {
    if (!text) return '';
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) {
      return text;
    }
    return words.slice(0, wordLimit).join(' ') + '...';
  }

  /**
   * Check if text exceeds word limit (for showing View More button)
   */
  hasMoreWords(text: string, wordLimit: number = 30): boolean {
    if (!text) return false;
    const words = text.trim().split(/\s+/);
    return words.length > wordLimit;
  }

  toggleInsightExpand(employeeId: string): void {
    // Toggle both insight and gap state together
    this.expandedInsightCards.has(employeeId)
      ? this.expandedInsightCards.delete(employeeId)
      : this.expandedInsightCards.add(employeeId);

    this.expandedGapCards.has(employeeId)
      ? this.expandedGapCards.delete(employeeId)
      : this.expandedGapCards.add(employeeId);
  }

  toggleGapExpand(employeeId: string): void {
    // This is now called from toggleInsightExpand, but kept for compatibility
    if (this.expandedGapCards.has(employeeId)) {
      this.expandedGapCards.delete(employeeId);
    } else {
      this.expandedGapCards.add(employeeId);
    }
  }

  openRejectRecommendedPopup(data){
    console.log('data',data)
    let reccdata  = {
        srNumber: data.srId,
        optionKey :'reject recommended',
        employeeId: this.header.empCode,
    }
    this.rejectReccModal.emit(reccdata);

  }
  openBlockedCandidatePopup (data:any){
    console.log('data',data)
      let candidateData  = {
        srNumber: data.srId,
        employeeId: [this.header.empCode],
        designation  :data.employeeResponseDTOemployeeResponseDTO?.designation
    }
    let emittedData = {
      basicInfo : candidateData,
      data :data
    }
    this.blockedCandidateModal.emit(emittedData);
  }

  openUnmapCandidatePopup(data: any) {
    console.log('data', data);
    const employee = data?.employeeResponseDTO || {};
    const emittedData = {
      srNumber: data.srId,
      employee: {
        employeeName: employee?.employeeName ?? this.header.title ?? '',
        employeeId: employee?.employeeId ?? this.header.empCode ?? '',
      },
      data: data,
    };
    this.unmapCandidateModal.emit(emittedData);
  }

  displayedView :string = 'MAPPED';
  
  allTabs:any []  = [
    { id: 'MAPPED', label: 'Mapped SRs' },
    { id: 'EMPLOYEE_HISTORY', label: 'Employee History' }
  ];

  //Toggle the view
  toggleView(viewId: string): void {
    this.displayedView = viewId;
    this.showBackToTop = false;
    this.query = '' // clear serach text
    if (this.displayedView=='MAPPED'){
      this.searchChange.emit('');
    }
    else{
      //  Clear or reset the array so the child gets a fresh payload/reference
      this.allEmployeeHistoryData = [];
      this.searchChangeOnEmployeeHistory.emit('');
    }
  }
  // History varaibles

  steps: { key: StepKey; label: string }[] = [
    { key: 'open', label: 'UnMapped' },
    { key: 'mapped', label: 'Mapped' },
    { key: 'recommended', label: 'Recommended' },
    { key: 'blocked', label: 'Blocked' },
    { key: 'selected', label: 'Selected' },
    { key: 'closed', label: 'Closed' },
  ];
  get areAllSRStatsCountZero(): boolean {
    return (
      this.SRStatsCount.candidatesMapped === 0 &&
      this.SRStatsCount.candidatesRecommended === 0 &&
      this.SRStatsCount.candidatesRejected === 0 &&
      this.SRStatsCount.candidatesBlocked === 0 &&
      this.SRStatsCount.candidatesSelected === 0
    );
  }


  getConnectorClass(stepKey: StepKey): string {
    if (this.isStepCompleted(stepKey)) {
      return 'bg-primary_Bg_Button_Color';
    }
    if (this.isStepActive(stepKey)) {
      return 'border-t-2 border-dotted border-primary_Bg_Button_Color';
    }
    return 'border-t-2 border-dotted border-gray-300';
  }
  
    /** ---------- CORE LOGIC ---------- */
  get closedDateDisplay(): string | null {
    const closedHistory = this.allEmployeeHistoryData?.find(
      (historyItem) => !!historyItem?.closedDate,
    );
    return closedHistory?.closedDate || null;
  }

  get activeStep(): StepKey {
    if (!this.SRStatsCount) return 'open';
    if (this.SRStatsCount.candidatesMapped === 0) return 'open';
    if (this.SRStatsCount.candidatesRecommended === 0) return 'mapped';
    if (this.SRStatsCount.candidatesBlocked === 0) return 'recommended';
    if (this.hasClosedDate) return 'closed';
    if (this.SRStatsCount.candidatesSelected === 0) return 'blocked';
    //  if (this.stats.closed === 0) return 'selected';
    return 'selected';
  }

  get hasClosedDate(): boolean {
    return !!this.closedDateDisplay;
  }
    isStepActive(step: StepKey): boolean {
    return this.activeStep === step;
  }

  isStepCompleted(step: StepKey): boolean {
    if (step === 'closed' && this.hasClosedDate) {
      return true;
    }

    const order = this.steps.map((s) => s.key);
    return order.indexOf(step) < order.indexOf(this.activeStep);
  }

  isStepDisabled(step: StepKey): boolean {
    return !this.isStepActive(step) && !this.isStepCompleted(step);
  }

  // Download Excelreport for EmployeeHistory
  downloadReportForEmployeeHistory(){
    this.loading = true;
    this._staffingService.downlaodEmployeeHistoryByEmployeeId(this.header.empCode).subscribe({
      next: (response: any) => {
        if (response && response.statusCode == HttpStatusCode.Ok) {
          this.loading = false;
          try {
            setTimeout(() => {
              console.log(response, 'reponse');
              let fileType: any =
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              let link = document.createElement('a');
              link.href = `data:${fileType};base64,${response.data}`;
              const timestamp = new Date().toISOString()?.split('T')[0];
              link.download = `${this.header.title?.replaceAll(' ', '_')}_${this.header.empCode}_sr_history_${timestamp}.xlsx`;
              link.click();
              this._toast.success(response.message, 'Success');
            }, 500);
          } catch (err) {
            console.log(err);
          }
        }
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  reAssignAssessment(data:any,type:string){
    console.log(data);
    let Payload = {
      "toEmail":data?.employeeResponseDTO?.email,
      "employeeId":data?.employeeResponseDTO?.employeeId,
      "srNumber": this.openId,
      "mailType": type
    }
    console.log('Payload',Payload)
    this.commonHoverForId = null;
    this.reTriggerAssessment.emit(Payload);
  }

  // Click fired when clikced em history sr number dashed
  navigateToCandidateList(dynamicSRNumber:string){
    // this.closeModal()
    let  queryParams = {
      "srNumber": dynamicSRNumber,
      "designation": this.filteredRows[0].role, //designation
      "filterKey": "Iqigai mapped",
      "empId" : this.header.empCode
    }
    this.router.navigate([this._commonServices.Navigations.MAPPED_CANDIDATE], {
      queryParams,onSameUrlNavigation: 'reload'
    });
    sessionStorage.removeItem('queryParams');
    queryParams['searchkey']  =  '';
    queryParams['fromEmployeeHistory']  =  true;
    queryParams['isNavigatedEmployeeHistory']  =  true;
    queryParams['page']  =  0;
    queryParams['sortBy'] = '';
    queryParams['sortDirection']= ''
    sessionStorage.setItem('queryParams', JSON.stringify(queryParams));
  }

  


}
